import React, { useState,useEffect } from "react";
import { connect } from "react-redux";
import { withRouter,Redirect, useHistory } from 'react-router-dom';
import { toast, cssTransition } from "react-toastify";
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  loginUser,
  loginFromWeb,
  getUserDetailsV1,
  sendOTP,
  validateOTP,
  checkOTP,
  userAssign,
  removeLocalStorage
} from "../../../store/actions/authActionCreators";
import { getFilteredConfig } from "../../../store/actions/userActionCreators";
import OtpInput from "react-otp-input";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import { loginEvent } from '../../../analytics';
import Paper from '@material-ui/core/Paper';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from '@material-ui/core/Divider';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import CallIcon from '@material-ui/icons/Call';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Timer from 'react-compound-timer';
import { Dialog, DialogActions } from "@material-ui/core";
import Link from '@material-ui/core/Link';
import { MobileIcon } from '../../../components/icons';
import { checkScreen } from '../../../utils/utils';
import * as logger from "../../../logger";
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import CloseIcon from '@material-ui/icons/Close';
import { trackDwebEvent, loginDwebEvent, logoutDwebEvent } from '../../analytics';
import {
  getSubscriptionPlans, paySubscriptionAction, getSubscriptionStatus,
  updateFreeTrialModal
} from "../../../store/actions/paymentsActionCreator";
import queryString from "query-string";
import './loader.css';
//Styling used.
const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    }
  }));
  const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#00865a',
    },
  }))(LinearProgress);
const AuthPage = ({user,dispatchLoginFromWeb,dispatchLoginAction, dispatchGetSubscriptionStatusAction, 
  dispatchValidateOtpAction, dispatchCheckOtp, dispatchAssignUser, 
  dispatchGetFilteredConfig }) => {
  let search = window.location.search;
   const values = queryString.parse(search);
  //Assign styles to classes.
  const classes = useStyles();
  const history = useHistory();
  const gotoMain = () => {
    history.push({
      pathname: '/',
      state: {
        id: 7,
        pageTitle: 'Dashboard'
      }
    });
  }
  const goto500 = () => {
    history.push({
      pathname: '/500'
    });
  }
  const goToPremium = (data) => {
    const userInfoLocalStorage = JSON.parse(localStorage.getItem('USER_INFO'));
    // if ((userInfo && userInfo.role && userInfo.role != "USER") || (userInfoLocalStorage && userInfoLocalStorage.userInfo && userInfoLocalStorage.userInfo.role != "USER")) {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
    // }
  }
  useEffect(()=>{
    if (values && values.web) {
      let user = JSON.parse(localStorage.getItem("USER_INFO"));
      if (user) {
        localStorage.removeItem("USER_INFO");
      }
      let token= {}
      let splitted = values.web.split('tpbook');
      if (splitted[0]) {
        localStorage.setItem("USER_FROM_WEB", splitted[0]);
        token.accessToken = splitted[0];
      }
      if (splitted[1]) {
        localStorage.setItem("USER_FROM_WEB_ID", splitted[1]);
        token.tokenId = splitted[1];
      }
      if (splitted[2]) {
        localStorage.setItem("USER_FROM_WEB_REFRESH", splitted[2]);
        token.refreshToken = splitted[2];
      }
      dispatchLoginFromWeb(token,(data) => {
        if (data && data.status && data.status.code === 200) {
          loginDwebEvent(data.response.user);
          trackDwebEvent("Login Successfully! from TransportBook.in");
          let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
          if (userInfo && userInfo.isLoggedIn) {

            const requestData = {
              filteredKeys: ["online_payments_config", "dwebSearchBebounceMs", "panRegex", "gstRegex", "pincodeRegex",
                "GST_STATE_LIST", "subscription", "coming_soon", "VehicleRegex", "event_tracking"]
            }      
            

            dispatchGetFilteredConfig(
              requestData,
              (data) => {
              if (data && data.status && data.status.code === 200) {
                let config = data.response;
                let pre = config && config.subscription && config.subscription.enabled && config.subscription.enabled == 1 ? true : false;
                if (pre) {
                  dispatchGetSubscriptionStatusAction(
                    (res) => {
                      if (res && res.status && res.status.code === 200 && res.response) {
                        let status = res.response;
                        if (
                          (status && typeof status.isExpired != 'undefined' && status.isExpired) ||
                          (userInfo && typeof userInfo.isSubscriptionActive != 'undefined' && !userInfo.isSubscriptionActive)
                        ) {
                          if (userInfo && userInfo.userInfo && userInfo.userInfo.role != "USER") {
                            goToPremium();
                          }
                        }
                      }
                    },
                    () => {
                    })
                }
                history.push('/')
              }
            }, () => {
  
            });
          }
        }
      }, () => {
        history.push('/external')
      });
    }else{
      history.push('/external')
    }
  },[])
  return (
    <>
         <div id="tp-load-spinner-fade">
            <div>
              <img style={{marginBottom:64}} src={`${process.env.PUBLIC_URL}/assets/images/loader_logo.svg`} alt={"Transport Footer"} />
              <BorderLinearProgress />
            </div>
        </div>
    </>
  );
};
const mapDispatchToProps = (dispatch) => ({
    dispatchLoginFromWeb: (data, onSuccess, onError) => dispatch(getUserDetailsV1(data,onSuccess, onError)),
  dispatchLoginAction: (mobileNumber, onSuccess, onError) =>
    dispatch(sendOTP({ mobileNumber }, onSuccess, onError)),
  dispatchValidateOtpAction: (mobileNumber, OTP, onSuccess, onError) =>
    dispatch(
      validateOTP({ number: mobileNumber, otp: OTP }, onSuccess, onError)
    ),
  dispatchCheckOtp: (mobileNumber, OTP, onSuccess, onError) =>
    dispatch(
      checkOTP({ number: mobileNumber, otp: OTP }, onSuccess, onError)
    ),
  dispatchAssignUser: (userInfo) =>
    dispatch(
      userAssign(userInfo)
    ),
  dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionStatus(onSuccess, onFailure))
  },
  dispatchGetFilteredConfig: (data, onSuccess, onFailure) => {
    dispatch(getFilteredConfig(data, onSuccess, onFailure))
  }
});
export default connect(null, mapDispatchToProps)(AuthPage);